import React from "react";
import { Layout } from "antd";
import "./BasicLayout.less";
const { Footer } = Layout;

export default ({ children }) => (
  <div className="content-basic">
    {children}
    <Footer className="footer">E-kanban<br />&copy; 2025 Sankei Dharma Indonesia</Footer>
  </div>
);
